<template>
  <div class="ChangePassword">
    <div class="list">

      <div class="item">
        <input type="text" placeholder="填写真实姓名" v-model="real_name" />
      </div>

      <div class="item">
        <date-picker :date="startTime" :option="option"></date-picker>
      </div>

      <div class="item">
        <input type="number" placeholder="填写手机号码" v-model="phone" />
      </div>


      <div class="item acea-row row-between-wrapper">
        <input
          type="text"
          placeholder="填写验证码"
          class="codeIput"
          v-model="captcha"
        />
        <button
          class="code font-color-red"
          :disabled="disabled"
          :class="disabled === true ? 'on' : ''"
          @click="code"
        >
          {{ text }}
        </button>
      </div>


      <div class="item">
        <input type="text" placeholder="备注" v-model="mark" />
      </div>

    </div>
    <div class="confirmBnt bg-color-red" @click="confirm">确认绑定</div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getUser, registerVerify, bindingPhone } from "@api/user";
import myDatepicker from 'vue-datepicker/vue-datepicker-es6.vue'

export default {
  name: "BindingPhone",
  components: {
    'date-picker':myDatepicker
  },
  props: {},
  data: function() {
    return {
      captcha: "",
      real_name: "",
      birthday: "",
      mark: "",
      phone: "", //手机号
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        // week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        // month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '请选择出生日期',
        inputStyle: {
          'display': 'inline-block',
          'padding-top': '19px',
          'line-height': '22px',
          'font-size': '16px',
          'border-radius': '2px',
          'color': '#5F5F5F'
        },
        color: {
          header: '#ccc',
          headerText: '#f00'
        },
        buttons: {
          ok: '确定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm'
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format:"YYYY-MM-DD HH:mm"
      },
      limit: [{
        type: 'weekday',
        available: [1, 2, 3, 4, 5, 6, 7]
      },
        {
          type: 'fromto',
          from: '1970-01-01',
          to: '2019-12-31'
        }]
    }
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function() {
	    this.User();
  },
  methods: {
	  User: function() {
	    let that = this;
	    getUser().then(res => {
	      that.userInfo = res.data;
	      that.orderStatusNum = res.data.orderStatusNum;
		  that.real_name = res.data.real_name;
		  that.startTime.time = that.timestamptoTime(res.data.birthday);
		  that.phone = res.data.phone;
		  that.mark = res.data.mark;
	    });
	  },
	  
	  timestamptoTime: function(time){
		  var date = new Date(time * 1000);
		  var Y = date.getFullYear() + '-';
		  var m = (date.getMonth() + 1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
		  var d = date.getDate()
		  return Y+m+d;
	  },
    async confirm() {
      let that = this;
      const { phone, captcha, real_name, startTime, mark } = that;
      try {
        await that
          .$validator({
            phone: [
              chs_phone(chs_phone.message("手机号码")),
              alpha_num(alpha_num.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ phone, captcha,real_name, startTime, mark });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      bindingPhone({
        phone: this.phone,
        captcha: this.captcha,
        real_name: this.real_name,
        birthday: this.startTime.time,
        mark: this.mark,
      })
        .then(res => {
          if (res.data !== undefined && res.data.is_bind) {
            that.$dialog.confirm({
              mes: res.msg,
              opts: [
                {
                  txt: "确认绑定",
                  color: false,
                  callback: () => {
                    bindingPhone({
                      phone: this.phone,
                      captcha: this.captcha,
                      real_name: this.real_name,
                      birthday: this.birthday,
                      mark: this.mark,
                      step: 1
                    })
                      .then(res => {
                        that.$dialog.success(res.msg).then(() => {
                          that.$router.replace({ name: "PersonalData" });
                        });
                      })
                      .catch(res => {
                        that.$dialog.error(res.msg).then(() => {
                          that.$router.replace({ name: "PersonalData" });
                        });
                      });
                  }
                },
                {
                  txt: "取消",
                  color: false,
                  callback: () => {
                    that.$dialog.error("已取消绑定").then(() => {
                      that.$router.replace({ name: "PersonalData" });
                    });
                  }
                }
              ]
            });
          } else {
            that.$dialog.success(res.msg).then(() => {
              that.$router.replace({ name: "PersonalData" });
            });
          }
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      let that = this;
      const { phone } = that;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
	  
	  

      registerVerify({ phone: phone })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
		
    }
  }
};
</script>
